import { isEmpty } from 'lodash'

import { apiEndpoints } from './common'

import { makeRequestUrl } from '../app/helpers'
import { get } from '../request'

const fetchMakeUpSession = async ({ url, queries } = {}) => {
  const requestUrl = !isEmpty(url)
    ? url
    : makeRequestUrl(`${apiEndpoints.make_up_session}`, queries)

  try {
    const response = await get(requestUrl)

    return {
      results: response.data
    }
  } catch (error) {
    console.log('error in fetching make-up sessions :- ', error.message)
    throw error
  }
}

export { fetchMakeUpSession }
